const DynamicVideos = () => {
  const dynamicVideos: NodeListOf<HTMLMediaElement> = document.querySelectorAll('[data-dynamic-video="true"]');
  if (dynamicVideos.length == 0) {
    return;
  }

  // Loads the video source based on the browser and available sources. This is called when the video comes into view.
  const loadVideoSource = (videoPlayer: HTMLMediaElement) => {
    // Create a temporary video element to test codec support.
    const tester = document.createElement('video');
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const mp4Src = videoPlayer.dataset.mp4Src;
    const webmSrc = videoPlayer.dataset.webmSrc;
    const ignoreMissing = videoPlayer.dataset.ignoreMissing === 'true';
    let finalSrc: string | null = null;

    // Prioritize MP4 (HEVC) for Safari, if available and supported.
    if (isSafari && mp4Src && tester.canPlayType('video/mp4; codecs="hvc1"')) {
      finalSrc = mp4Src;
    }
    // For other modern browsers (Chrome, Firefox), WebM is the standard for transparency.
    else if (!isSafari && webmSrc && tester.canPlayType('video/webm; codecs="vp9"')) {
      finalSrc = webmSrc;
    }
    // Fallback to the first available source.
    else if (webmSrc && ignoreMissing) {
      finalSrc = webmSrc;
    } else if (mp4Src && ignoreMissing) {
      finalSrc = mp4Src;
    }

    if (finalSrc) {
      // Create and dispatch a custom event after the video is able to be played.
      videoPlayer.addEventListener('canplay', () => {
        const sourceSetEvent = new CustomEvent('dynamicSourceSet', {
          bubbles: true,
          detail: {
            videoElement: videoPlayer,
            sourceUsed: finalSrc
          }
        });
        videoPlayer.dispatchEvent(sourceSetEvent);
      });
      // Set the determined source, which triggers the download.
      videoPlayer.src = finalSrc;
    }
  };

  // Setup the Intersection Observer
  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach(entry => {
      // Check if the video is in the viewport
      if (entry.isIntersecting) {
        const video = entry.target as HTMLMediaElement;
        // Load the video source
        loadVideoSource(video);
        // Stop observing this video since it has been loaded
        observerInstance.unobserve(video);
      }
    });
  });

  // Start observing each video
  dynamicVideos.forEach(video => {
    observer.observe(video);
  });
}

export default DynamicVideos;
